import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { SettingsShell } from '@/features/settings/components/Layouts'
import { PATH_SETTINGS } from '@/routes/const'
import { Profile, Security } from '../panel'

export const PanelRoot = () => {
  return (
    <Routes>
      <Route element={<SettingsShell />}>
        <Route path={PATH_SETTINGS.PROFILE} element={<Profile />} />
        <Route path={PATH_SETTINGS.SECURITY} element={<Security />} />
      </Route>

      <Route path={'*'} element={<Navigate to={PATH_SETTINGS.PROFILE} replace={true} />} />
    </Routes>
  )
}
